import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { Toolbar } from "primereact/toolbar";

export interface IAddRequirementType{
    reqType_ID?: number | null,
    reqType?: string | null,
    description?: string | null,
    user_Added_by?: number | null,
    createdOn?: Date | null,
}

interface Iprops {
    setModal: (modal: any) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyAddReuirementType: IAddRequirementType = {
    reqType: "",
    description: "",
}

export const Table=(props: Iprops)=>{
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAddRequirementType>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>: ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Add Requirement Type</h5>
        </div>
    );

    const openNew=()=>{
        props.setModal({ open: true, singleData: EmptyAddReuirementType });
    };
    const openEdit=(rowData: IAddRequirementType)=>{
        props.setModal({ open: true, singleData: rowData });
    };

    const action=(rowData: IAddRequirementType)=>{
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={()=>openEdit(rowData)}></Button>
            </div>
        );
    }

    const loadTableData = async ()=>{
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("RequirementType_Mast", "GET", null, null, props.toast);
        if(response){
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="reqType" header="Req Type"/>
                <Column field="description" header="Description"/>
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
            </DataTable>
        </>
    );
}